<template>
	<div
		id="config-detail"
		:class="[!isWeb ? 'mobile-config-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToAdmins()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Adicionar Administrador' : 'Editar Administrador' }}
			</h1>
		</div>
		<AdminForm :isWeb="isWeb" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import AdminForm from '@/components/modules/Administrator/Administrator/AdminForm/AdminForm.vue';

export default {
	name: 'AdministratorDetail',
	components: { SidebarArrow, AdminForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToAdmins() {
			this.$router.push({ path: '/dashboard/admins' });
		},
	},
	computed: {
		...mapGetters('userManagement', ['isLoadingUsers']),
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'AdministratorDetail.scss';
</style>
